import { useInfiniteQuery } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { ISearchPackageResultPayload } from '../../../types';

/**
 * This is to track search package api state.
 */
export const SEARCH_PACKAGE_QUERY_KEY = 'search-package-query-key';

/**
 * This hook fetches the inbound Pod Details from mock APi.
 */
export const useSearchPackageQuery = (payload: ISearchPackageResultPayload) => {
  const {
    endDate,
    limit,
    page,
    search,
    searchFields,
    searchKeywords,
    location,
    sort,
    startDate,
  } = payload;

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      SEARCH_PACKAGE_QUERY_KEY,
      endDate,
      location,
      limit,
      page,
      search,
      searchFields,
      searchKeywords,
      sort,
      startDate,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    retry: false,
    queryFn: ({ pageParam = 1 }) =>
      INV_MGMT_SERVICE_API.getPackageList({ ...payload, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.isMultipleLocation) return undefined;

      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * (limit || 20);

      return currentCount < lastPage.total ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
